import TextMessage from './TextMessage';
import ImageMessage from './ImageMessage';
import AudioMessage from './AudioMessage';
import DocumentMessage from './DocumentMessage';

const MessageContent = ({ details }) => {
  if (!details) return null;

  const type = details.type || (details.message ? 'text' : undefined);

  switch (type) {
    case 'text':
      return <TextMessage details={details} />;
    // 🔴 Cada tipo va con sus sinónimos. Los emisores no se pusieron de acuerdo:
    // Maytapi escribe `ptt` y en inglés, el navegador escribe `audio`, y los
    // envíos manuales llegaron a guardar `documento` en castellano. Lo que no
    // casaba caía en el `default` y se pintaba como texto — o sea, el mensaje
    // "[documento] justificante.pdf" tal cual, sin saber que era un adjunto.
    case 'image':
    case 'imagen':
    case 'camera':
      return <ImageMessage details={details} />;
    case 'ptt':
    case 'audio':
      return <AudioMessage details={details} />;
    case 'document':
    case 'documento':
      return <DocumentMessage details={details} />;
    default:
      return details.message ? <TextMessage details={details} /> : null;
  }
};

export default MessageContent;
